import { gql } from '@apollo/client'

export const Query = gql`
  query PackageAssetTypes(
    $companyId: ID!,
    $filters: PackageAssetTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    packageAssetTypes(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        assetType {
          id
          name
        }
        package {
          id
          name
        }
        quantity
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
